<template>
  <v-app>
    <v-container fluid style="width: 600px">
      <div class="mb-5">
        <h1>Convert GIF file to Animation file</h1>
      </div>
      <div class="mb-5">
        <a href="https://github.com/yulei/vial-gui/releases">modified vial which support file converting </a>
      </div>
      <div class="mb-5">
        <a href="/convert/datetime">Datetime setting</a>
      </div>
      <div class="mb-5">
        Note: the uploaded files will be made public to everyone and you can't delete the uploaded files. So DO NOT upload personal privacy related files!
      </div>
      <div class="mb-5">
        注意: 上传的文件将会对所有人公开，请勿上传个人隐私相关文件。若错误上传，可连续上传5个其它文件将其顶出列表。
      </div>
      <upload-files></upload-files>
    </v-container>
  </v-app>
</template>

<script>
import UploadFiles from "./components/UploadFiles";

export default {
  name: "App",
  components: {
    UploadFiles,
  },
};
</script>
